<script>
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import CallLiveText from "%/dynamic-component-editor/options/call-live-text";
import CallIdleText from "%/dynamic-component-editor/options/call-idle-text";
import HideWhenIdle from "%/dynamic-component-editor/options/hide-when-idle";
import { ConversationCallElementMixin }
  from "%/dynamic-component-editor/standard-elements/conversation-call/conversation-call-element-mixin";

export default {
  name: "ConversationCallStatus",
  extends: BrandedTextElement,
  mixins: [DynamicElementMixin, DynamicElementWithContext, ConversationCallElementMixin],
  elementPanelSettings: {
    displayName: "Call Status",
    elementGroup: "general",
    displayIcon: "video",
    elementType: "element",
  },
  hidden: true,
  // The words come from Live/Idle Text, so the free "Text" row is hidden.
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
  ],
  options: [CallLiveText, CallIdleText, HideWhenIdle],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      if (this.isCallPlaceholder || this.callPresence.active) {
        return this.getOptionValue(CallLiveText);
      }

      return this.getOptionValue(HideWhenIdle) ? "" : this.getOptionValue(CallIdleText);
    },
    shouldShowText() {
      return Boolean(this.value) || this.editMode;
    },
  },
};
</script>
